import React from 'react';
import '../../../css/artist/chats/ArtistEventNotes.css';
import ChatNotesPanel from '../../common/chat/notes/ChatNotesPanel';

const API_URL = process.env.REACT_APP_API_URL;

const ArtistPersonalNotesPanel = ({ artistId, onModeChange, onNotesChanged }) => (
  <ChatNotesPanel
    ownerId={artistId}
    rootClassName="artist-notes-panel"
    title="ノート"
    buildListUrl={(ownerId, offset = 0, limit = 20) => `${API_URL}/api/artist/personal-chat-notes/${ownerId}?offset=${offset}&limit=${limit}`}
    createUrl={`${API_URL}/api/artist/personal-chat-notes`}
    buildUpdateUrl={(noteId) => `${API_URL}/api/artist/personal-chat-notes/${noteId}`}
    buildDeleteUrl={(noteId) => `${API_URL}/api/artist/personal-chat-notes/${noteId}`}
    buildDetailUrl={(noteId) => `${API_URL}/api/personal-chat-notes/detail/${noteId}`}
    onModeChange={onModeChange}
    onNotesChanged={onNotesChanged}
    openDetailEventName="artist-personal-notes-open-detail"
    closeDetailEventName="artist-personal-notes-close-detail"
    closeImageEventName="artist-personal-notes-close-image"
  />
);

export default ArtistPersonalNotesPanel;
